import React, { useState } from 'react';
import { X, Plus, Zap, FileText, User, Sparkles, Search, CheckCircle, Clock, Lock, Eye, Send, Star, Users, Layers, TrendingUp, CalendarDays } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
interface AutoServiceDetailProps {
  activeAutoService: string;
  setActiveAutoService: (service: string | null) => void;
  showToast: (msg: string) => void;
}
export function AutoServiceDetail({
  activeAutoService,
  setActiveAutoService,
  showToast
}: AutoServiceDetailProps) {
  const [autoServiceTab, setAutoServiceTab] = useState<'create' | 'archive'>('archive');
  const autoServicesData: Record<string, {
    title: string;
    icon: any;
    color: string;
    total: number;
    used: number;
    active: boolean;
    reports: Array<{
      id: number;
      client: string;
      date: string;
      status: 'ready' | 'processing' | 'locked';
      birthDate: string;
      city: string;
    }>;
  }> = {
    natal: {
      title: 'Натальная карта',
      icon: FileText,
      color: 'indigo',
      total: 1000,
      used: 153,
      active: true,
      reports: [{
        id: 1,
        client: 'Мария Волкова',
        date: '15 Окт 2024',
        status: 'ready',
        birthDate: '12.03.1990',
        city: 'Москва'
      }, {
        id: 2,
        client: 'Дмитрий Романов',
        date: '14 Окт 2024',
        status: 'ready',
        birthDate: '05.07.1985',
        city: 'Санкт-Петербург'
      }, {
        id: 3,
        client: 'Анна Козлова',
        date: '13 Окт 2024',
        status: 'processing',
        birthDate: '22.11.1992',
        city: 'Казань'
      }, {
        id: 4,
        client: 'Ольга Петрова',
        date: '10 Окт 2024',
        status: 'ready',
        birthDate: '01.06.1988',
        city: 'Новосибирск'
      }, {
        id: 5,
        client: 'Иван Сидоров',
        date: '08 Окт 2024',
        status: 'ready',
        birthDate: '15.09.1995',
        city: 'Екатеринбург'
      }, {
        id: 6,
        client: 'Елена Тимофеева',
        date: '25 Сен 2024',
        status: 'ready',
        birthDate: '30.01.1987',
        city: 'Краснодар'
      }, {
        id: 7,
        client: 'Павел Морозов',
        date: '22 Сен 2024',
        status: 'ready',
        birthDate: '18.04.1991',
        city: 'Самара'
      }]
    },
    solar: {
      title: 'Соляр (Прогноз на год)',
      icon: Star,
      color: 'amber',
      total: 500,
      used: 47,
      active: true,
      reports: [{
        id: 1,
        client: 'Мария Волкова',
        date: '14 Окт 2024',
        status: 'ready',
        birthDate: '12.03.1990',
        city: 'Москва'
      }, {
        id: 2,
        client: 'Анна Козлова',
        date: '12 Окт 2024',
        status: 'ready',
        birthDate: '22.11.1992',
        city: 'Казань'
      }, {
        id: 3,
        client: 'Светлана Иванова',
        date: '05 Окт 2024',
        status: 'ready',
        birthDate: '08.12.1989',
        city: 'Ростов-на-Дону'
      }]
    },
    synastry: {
      title: 'Синастрия (Совместимость)',
      icon: Users,
      color: 'rose',
      total: 200,
      used: 89,
      active: true,
      reports: [{
        id: 1,
        client: 'Мария + Дмитрий',
        date: '15 Окт 2024',
        status: 'ready',
        birthDate: '12.03.1990 / 05.07.1985',
        city: 'Москва'
      }, {
        id: 2,
        client: 'Анна + Павел',
        date: '11 Окт 2024',
        status: 'ready',
        birthDate: '22.11.1992 / 18.04.1991',
        city: 'Казань'
      }]
    },
    combo: {
      title: 'Комбо (Натал + Соляр)',
      icon: Layers,
      color: 'emerald',
      total: 0,
      used: 0,
      active: false,
      reports: []
    },
    forecast: {
      title: 'Транзиты (Прогноз)',
      icon: TrendingUp,
      color: 'sky',
      total: 0,
      used: 0,
      active: false,
      reports: []
    },
    calendar: {
      title: 'Астро-календарь',
      icon: CalendarDays,
      color: 'purple',
      total: 0,
      used: 0,
      active: false,
      reports: []
    }
  };
  const svc = autoServicesData[activeAutoService];
  if (!svc) return null;
  const remaining = svc.total - svc.used;
  const ServiceIcon = svc.icon;
  return <div className="space-y-6" data-id="element-12774">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-12775">
        <div className="flex items-center gap-3" data-id="element-12776">
          <button onClick={() => {
          setActiveAutoService(null);
          setAutoServiceTab('archive');
        }} className="p-2 hover:bg-slate-100 rounded-full transition-colors -ml-2" data-id="element-12777">
            <X className="w-5 h-5 text-slate-500" data-id="element-12778" />
          </button>
          <div className={`w-10 h-10 rounded-xl bg-${svc.color}-100 flex items-center justify-center`} data-id="element-12779">
            <ServiceIcon className={`w-5 h-5 text-${svc.color}-600`} data-id="element-12780" />
          </div>
          <div data-id="element-12781">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-12782">{svc.title}</h2>
            <div className="text-xs text-slate-500" data-id="element-12783">Авто-генерация отчётов</div>
          </div>
        </div>
        {svc.active ? <div className="flex items-center gap-3" data-id="element-12784">
            <div className="text-right" data-id="element-12785">
              <div className="text-xs text-slate-500" data-id="element-12786">Остаток</div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12787">
                {remaining}{' '}
                <span className="text-xs text-slate-400 font-normal" data-id="element-12788">
                  / {svc.total}
                </span>
              </div>
            </div>
            <Button variant="outline" size="sm" icon={<Plus className="w-3.5 h-3.5" data-id="element-12790" />} onClick={() => showToast('Пакет генераций добавлен в корзину — 500 генераций за 990 ₽')} data-id="element-12789">
              Докупить
            </Button>
          </div> : <Button variant="primary" size="sm" icon={<Zap className="w-3.5 h-3.5" data-id="element-12792" />} onClick={() => showToast('Услуга подключена! Стартовый пакет: 100 генераций бесплатно')} data-id="element-12791">
            Подключить услугу
          </Button>}
      </div>

      {/* Balance bar */}
      {svc.active && <Card padding="sm" className="bg-slate-50 border-slate-100" data-id="element-12793">
          <div className="flex items-center justify-between text-xs mb-1.5 px-1" data-id="element-12794">
            <span className="text-slate-600" data-id="element-12795">
              Использовано:{' '}
              <span className="font-semibold text-slate-800" data-id="element-12796">{svc.used}</span>{' '}
              из {svc.total}
            </span>
            <span className={`font-medium ${remaining < svc.total * 0.15 ? 'text-rose-500' : 'text-emerald-600'}`} data-id="element-12797">
              {remaining < svc.total * 0.15 ? 'Заканчивается!' : `${Math.round((1 - svc.used / svc.total) * 100)}% свободно`}
            </span>
          </div>
          <div className="w-full bg-slate-200 rounded-full h-2 px-0" data-id="element-12798">
            <div className={`h-2 rounded-full transition-all ${remaining < svc.total * 0.15 ? 'bg-rose-500' : svc.used / svc.total > 0.5 ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{
          width: `${svc.used / svc.total * 100}%`
        }} data-id="element-12799" />
          </div>
        </Card>}

      {/* Tabs: Create / Archive */}
      {svc.active && <div className="flex gap-1 bg-white p-1 rounded-xl border border-slate-100 shadow-sm w-fit" data-id="element-12800">
          <button onClick={() => setAutoServiceTab('create')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${autoServiceTab === 'create' ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-12801">
            <span className="flex items-center gap-1.5" data-id="element-12802">
              <Plus className="w-4 h-4" data-id="element-12803" /> Создать отчёт
            </span>
          </button>
          <button onClick={() => setAutoServiceTab('archive')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${autoServiceTab === 'archive' ? 'bg-indigo-50 text-primary' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-12804">
            <span className="flex items-center gap-1.5" data-id="element-12805">
              <FileText className="w-4 h-4" data-id="element-12806" /> Архив отчётов
              <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full" data-id="element-12807">
                {svc.reports.length}
              </span>
            </span>
          </button>
        </div>}

      {/* Create Report Form */}
      {svc.active && autoServiceTab === 'create' && <Card padding="lg" data-id="element-12808">
          <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-12809">
            Создать новый отчёт
          </h3>
          <p className="text-sm text-slate-500 mb-6" data-id="element-12810">
            Введите данные клиента — отчёт будет сгенерирован автоматически и
            появится в архиве.
          </p>

          <form className="space-y-5" data-id="element-12811">
            {activeAutoService === 'synastry' ? <>
                <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-12812">
                  <div className="text-sm font-bold text-slate-700 mb-3 flex items-center gap-2" data-id="element-12813">
                    <User className="w-4 h-4 text-slate-500" data-id="element-12814" /> Первый партнёр
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12815">
                    <Input label="Имя" placeholder="Имя клиента" data-id="element-12816" />
                    <Input label="Дата рождения" type="date" data-id="element-12817" />
                    <Input label="Время рождения" type="time" data-id="element-12818" />
                    <Input label="Город рождения" placeholder="Москва" data-id="element-12819" />
                  </div>
                </div>
                <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-12820">
                  <div className="text-sm font-bold text-slate-700 mb-3 flex items-center gap-2" data-id="element-12821">
                    <User className="w-4 h-4 text-slate-500" data-id="element-12822" /> Второй партнёр
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12823">
                    <Input label="Имя" placeholder="Имя партнёра" data-id="element-12824" />
                    <Input label="Дата рождения" type="date" data-id="element-12825" />
                    <Input label="Время рождения" type="time" data-id="element-12826" />
                    <Input label="Город рождения" placeholder="Москва" data-id="element-12827" />
                  </div>
                </div>
              </> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12828">
                <Input label="Имя клиента" placeholder="Имя" data-id="element-12829" />
                <Input label="Дата рождения" type="date" data-id="element-12830" />
                <Input label="Время рождения" type="time" data-id="element-12831" />
                <Input label="Город рождения" placeholder="Москва" data-id="element-12832" />
                {(activeAutoService === 'solar' || activeAutoService === 'combo') && <>
                    <Input label="Год прогноза" type="number" placeholder="2025" defaultValue="2025" data-id="element-12833" />
                    <Input label="Город встречи соляра" placeholder="Где будет в день рождения" data-id="element-12834" />
                  </>}
              </div>}

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-4 border-t border-slate-100" data-id="element-12835">
              <div className="text-xs text-slate-500 flex items-center gap-1.5" data-id="element-12836">
                <Zap className="w-3.5 h-3.5 text-amber-500" data-id="element-12837" />
                Будет списана{' '}
                <span className="font-bold text-slate-700" data-id="element-12838">1 единица</span> из
                баланса ({remaining} осталось)
              </div>
              <Button variant="primary" icon={<Sparkles className="w-4 h-4" data-id="element-12840" />} onClick={() => {
            showToast('Отчёт генерируется... Появится в архиве через 1-2 минуты ✓');
            setAutoServiceTab('archive');
          }} data-id="element-12839">
                Сгенерировать отчёт
              </Button>
            </div>
          </form>
        </Card>}

      {/* Archive */}
      {svc.active && autoServiceTab === 'archive' && <div className="space-y-3" data-id="element-12841">
          {svc.reports.length === 0 ? <Card padding="lg" className="text-center py-16" data-id="element-12842">
              <FileText className="w-12 h-12 text-slate-300 mx-auto mb-4" data-id="element-12843" />
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-12844">Нет отчётов</h3>
              <p className="text-sm text-slate-500 mb-4" data-id="element-12845">
                Создайте первый отчёт — он появится здесь
              </p>
              <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12847" />} onClick={() => setAutoServiceTab('create')} data-id="element-12846">
                Создать отчёт
              </Button>
            </Card> : <>
              {/* Search */}
              <div className="relative w-full sm:w-72" data-id="element-12848">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-12849">
                  <Search className="h-4 w-4 text-slate-400" data-id="element-12850" />
                </div>
                <input type="text" placeholder="Поиск по имени клиента..." className="block w-full pl-10 pr-3 py-2 border border-slate-200 rounded-xl text-sm bg-white placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition-colors" data-id="element-12851" />
              </div>

              {/* Reports list */}
              {svc.reports.map(report => <Card key={report.id} padding="sm" className={`transition-all ${report.status === 'locked' ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12852">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-3 py-2" data-id="element-12853">
                    <div className="flex items-center gap-3 min-w-0" data-id="element-12854">
                      <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${report.status === 'ready' ? 'bg-emerald-100' : report.status === 'processing' ? 'bg-amber-100' : 'bg-slate-100'}`} data-id="element-12855">
                        {report.status === 'ready' ? <CheckCircle className="w-4.5 h-4.5 text-emerald-600" data-id="element-12856" /> : report.status === 'processing' ? <Clock className="w-4.5 h-4.5 text-amber-600" data-id="element-12857" /> : <Lock className="w-4.5 h-4.5 text-slate-400" data-id="element-12858" />}
                      </div>
                      <div className="min-w-0" data-id="element-12859">
                        <div className="flex items-center gap-2 mb-0.5" data-id="element-12860">
                          <span className="text-sm font-bold text-slate-900 truncate" data-id="element-12861">
                            {report.client}
                          </span>
                          <Badge variant={report.status === 'ready' ? 'success' : report.status === 'processing' ? 'warning' : 'neutral'} size="sm" data-id="element-12862">
                            {report.status === 'ready' ? 'Готов' : report.status === 'processing' ? 'Генерация...' : 'Заблокирован'}
                          </Badge>
                        </div>
                        <div className="text-[11px] text-slate-500" data-id="element-12863">
                          {report.date} • Рождение: {report.birthDate} •{' '}
                          {report.city}
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 flex-shrink-0" data-id="element-12864">
                      {report.status === 'ready' && <>
                          <Button variant="outline" size="sm" className="text-xs px-2.5 py-1 h-auto" icon={<Eye className="w-3.5 h-3.5" data-id="element-12866" />} onClick={() => showToast('Открытие отчёта...')} data-id="element-12865">
                            Открыть
                          </Button>
                          <Button variant="outline" size="sm" className="text-xs px-2.5 py-1 h-auto" icon={<FileText className="w-3.5 h-3.5" data-id="element-12868" />} onClick={() => showToast('Печать на фирменном бланке...')} data-id="element-12867">
                            Печать
                          </Button>
                          <Button variant="outline" size="sm" className="text-xs px-2.5 py-1 h-auto" icon={<Send className="w-3.5 h-3.5" data-id="element-12870" />} onClick={() => showToast('Отчёт отправлен клиенту ✓')} data-id="element-12869">
                            Отправить
                          </Button>
                        </>}
                      {report.status === 'processing' && <span className="text-xs text-amber-600 font-medium flex items-center gap-1" data-id="element-12871">
                          <Clock className="w-3.5 h-3.5 animate-pulse" data-id="element-12872" /> ~2 мин
                        </span>}
                      {report.status === 'locked' && <Button variant="primary" size="sm" className="text-xs px-3 py-1 h-auto" icon={<Lock className="w-3.5 h-3.5" data-id="element-12874" />} onClick={() => showToast('Отчёт разблокирован — списано 50 генераций')} data-id="element-12873">
                          Разблокировать
                        </Button>}
                    </div>
                  </div>
                </Card>)}
            </>}
        </div>}

      {/* Inactive service state */}
      {!svc.active && <Card padding="lg" className="text-center py-16" data-id="element-12875">
          <div className={`w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4`} data-id="element-12876">
            <ServiceIcon className="w-8 h-8 text-slate-400" data-id="element-12877" />
          </div>
          <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-12878">
            Услуга не подключена
          </h3>
          <p className="text-sm text-slate-500 mb-6 max-w-md mx-auto" data-id="element-12879">
            Подключите «{svc.title}» чтобы автоматически генерировать отчёты для
            клиентов. Купите пакет или отдельные единицы.
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-12880">
            <button onClick={() => showToast('1 шт добавлена ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-12881">
              Купить 1 шт
            </button>
            <button onClick={() => showToast('Пакет 100 шт оплачен ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors" data-id="element-12882">
              100 шт <span className="text-xs text-indigo-400" data-id="element-12883">-30%</span>
            </button>
            <button onClick={() => showToast('Пакет 500 шт оплачен ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100 transition-colors" data-id="element-12884">
              500 шт <span className="text-xs text-indigo-400" data-id="element-12885">-40%</span>
            </button>
            <button onClick={() => showToast('Пакет 1000 шт оплачен ✓')} className="text-sm font-medium px-4 py-2 rounded-lg border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 transition-colors" data-id="element-12886">
              1 000 шт <span className="text-xs text-amber-400" data-id="element-12887">-50%</span>
            </button>
          </div>
        </Card>}
    </div>;
}